import { useRef } from "react"
import { useBuiltinFieldRules } from "source/shared/hooks/useBuiltinFieldRules"
import { Select } from "source/shared/components"
import { Icon } from "source/shared/components"

type MembershipSelectProps = {
  value: string
  onChange: (value: string) => void
  memberships: Array<{ id: string; attributes: { value: string } }>
}

export function MembershipSelect({
  value,
  onChange,
  memberships,
}: MembershipSelectProps) {
  const membershipOptions = memberships?.map((m) => ({
    label: m.attributes.value,
    value: m.id,
  }))

  const { membership_type: membershipTypeEditingRule } = useBuiltinFieldRules()

  const valueRef = useRef(value)

  const disabled =
    membershipTypeEditingRule === "view" ||
    !!(membershipTypeEditingRule === "add_if_blank" && valueRef)

  const handleChange = (e: { target: { value: string } }) =>
    onChange(e.target.value)

  return (
    <>
      <div className="d-f">
        <label htmlFor="membership">Membership type</label>
        <span className="screen-reader-text">Membership type</span>
        {disabled && <Icon symbol="general#lock" className="fs-2 pl-1 pt-1" />}
      </div>
      <Select
        disabled={disabled}
        name="membership"
        value={value}
        onChange={handleChange}
        options={[{ label: "Select...", value: "" }, ...membershipOptions]}
      />
    </>
  )
}
